import type { CurrentSubscription } from '@setplex/tria-api'

import { api } from '@setplex/tria-api'
import { attach, createEvent, createStore, sample } from 'effector'

export const getCurrentSubscriptionFx = attach({
  effect: api.subscriptions.getCurrentSubscriptionFx,
})

export const resetCurrentSubscription = createEvent()
const currentSubscriptionLoaded = createEvent<CurrentSubscription>()

export const $currentSubscription = createStore<CurrentSubscription | null>(
  null
)
  .on(currentSubscriptionLoaded, (_, subscription) => subscription)
  .reset(resetCurrentSubscription)

sample({
  clock: getCurrentSubscriptionFx.doneData,
  target: currentSubscriptionLoaded,
})
